import { Fuel, Wrench, Utensils, HandCoins, Banknote, Building2 } from 'lucide-react';

export const EXPENSE_CATEGORIES = [
  { value: 'logistik', label: 'Logistik (Bahan Bakar)', icon: Fuel, color: 'bg-orange-100 text-orange-700', accent: 'text-orange-600' },
  { value: 'perawatan_kendaraan', label: 'Perawatan Kendaraan', icon: Wrench, color: 'bg-slate-100 text-slate-700', accent: 'text-slate-600' },
  { value: 'konsumsi', label: 'Konsumsi', icon: Utensils, color: 'bg-amber-100 text-amber-700', accent: 'text-amber-600' },
  { value: 'kasbon_karyawan', label: 'Kasbon Karyawan', icon: HandCoins, color: 'bg-rose-100 text-rose-700', accent: 'text-rose-600' },
  { value: 'gaji_karyawan', label: 'Gaji Karyawan', icon: Banknote, color: 'bg-blue-100 text-blue-700', accent: 'text-blue-600' },
  { value: 'beban_perusahaan', label: 'Beban Perusahaan', icon: Building2, color: 'bg-violet-100 text-violet-700', accent: 'text-violet-600' },
];

// Categories that Finance-role users can pick from directly.
// Salary & company burden are Owner-only (via dedicated modules).
export const FINANCE_ONLY_CATEGORIES = ['logistik', 'perawatan_kendaraan', 'konsumsi', 'kasbon_karyawan'];

export function catMeta(value) {
  return EXPENSE_CATEGORIES.find((c) => c.value === value) || { value, label: value || '-', icon: null, color: 'bg-muted', accent: 'text-muted-foreground' };
}

// Employee categories (master list)
import { Briefcase, Megaphone, TrendingUp, Crown, Package } from 'lucide-react';
export const EMPLOYEE_CATEGORIES = [
  { value: 'office', label: 'Office', icon: Briefcase, color: 'bg-sky-100 text-sky-700' },
  { value: 'marketing', label: 'Marketing', icon: Megaphone, color: 'bg-pink-100 text-pink-700' },
  { value: 'sales', label: 'Sales', icon: TrendingUp, color: 'bg-emerald-100 text-emerald-700' },
  { value: 'owner', label: 'Owner', icon: Crown, color: 'bg-violet-100 text-violet-700' },
  { value: 'gudang', label: 'Gudang', icon: Package, color: 'bg-amber-100 text-amber-700' },
];
export function empCatMeta(value) {
  return EMPLOYEE_CATEGORIES.find((c) => c.value === value) || { value, label: value || '-', icon: Briefcase, color: 'bg-muted' };
}
